import {
  ADD_EDIT_DAYS_OF_WEEK,
  ADD_EDIT_PERIOD_TIME_RANGE,
  ADD_EDIT_SEASON_DATE_RANGE,
  ADD_EDIT_TARIFF_FEATURE,
  ADD_EDIT_TARIFF_FEATURE_PERIOD,
  ADD_EDIT_TOU_PERIOD,
  CLEAR_TARIFF,
  DELETE_PERIOD_TIME_RANGE,
  DELETE_SEASON_DATE_RANGE,
  DELETE_TARIFF_FEATURE,
  DELETE_TARIFF_FEATURE_PERIOD,
  DELETE_TOU_PERIOD,
  GET_SITE_TARIFF_LIST_FAILURE,
  GET_SITE_TARIFF_LIST_REQUEST,
  GET_SITE_TARIFF_LIST_SUCCESS,
  GET_UNIT_TARIFF_LIST_FAILURE,
  GET_UNIT_TARIFF_LIST_REQUEST,
  GET_UNIT_TARIFF_LIST_SUCCESS,
  POST_TARIFF_FAILURE,
  POST_TARIFF_REQUEST,
  POST_TARIFF_SUCCESS,
  RESET_TARIFF_DETAILS,
  SET_SELECTED_CONFIGURED_SEASON,
  UPDATE_TARIFF_FAILURE,
  UPDATE_TARIFF_REQUEST,
  UPDATE_TARIFF_SUCCESS,
} from "actions/tariff";
import {
  GET_TARIFF_DETAILS_FAILURE,
  GET_TARIFF_DETAILS_REQUEST,
  GET_TARIFF_DETAILS_SUCCESS,
} from "actions/tariff";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import { cloneDeep, isEmpty, orderBy } from "lodash";
import {
  convertSeasonToChart,
  deleteTariffPeriodTimeRange,
  deleteUpdteSeasonDateRange,
  getTariffSeasons,
  initialTariff,
  updatePeriodTimeRange,
  updateSeasonDateRange,
} from "utils/tariff";
import { getTariffColorsByPrices } from "empower-energy-owner-components/dist/TariffChart/chartUtils";

dayjs.extend(advancedFormat);

const initialState = {
  loading: false,
  error: {},
  siteTariffList: [],
  unitTariffList: [],
  currentUnitTariffList: [],
  details: initialTariff,
  tariffPrices: [],
  tariffSeasons: [],
  tariffSeasonChart: [],
  tariffColors: [],
  selectedConfiguredSeason: null,
  isTariffUpdated: false,
  tariffFeatures: {},
};

const orderTariffSeasons = (tariffSeasons) =>
  orderBy(tariffSeasons, ["start_month"], "asc");

const updateTimePeriodName = (data, oldName, newName) => {
  return data.map((item) => {
    return {
      ...item,
      days_of_week: item.days_of_week.map((dow) => ({
        ...dow,
        time_periods: dow.time_periods.map((tp) => ({
          ...tp,
          name: tp.name === oldName ? newName : tp.name,
        })),
      })),
    };
  });
};

export default function tariff(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_SITE_TARIFF_LIST_REQUEST:
    case GET_UNIT_TARIFF_LIST_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }

    case GET_SITE_TARIFF_LIST_SUCCESS: {
      return {
        ...state,
        loading: false,
        siteTariffList: payload,
      };
    }

    case GET_UNIT_TARIFF_LIST_SUCCESS: {
      const { list, viewAllTariffs } = payload;
      const currentUnitTariffList = viewAllTariffs
        ? state.currentUnitTariffList
        : list;
      const ids = currentUnitTariffList.map((it) => it.id);
      return {
        ...state,
        loading: false,
        unitTariffList: list.map((it) => {
          return {
            ...it,
            selectedInCurrentSite: ids.includes(it.id),
          };
        }),
        currentUnitTariffList,
      };
    }

    case GET_SITE_TARIFF_LIST_FAILURE:
    case GET_UNIT_TARIFF_LIST_FAILURE: {
      return {
        ...state,
        loading: false,
      };
    }

    case GET_TARIFF_DETAILS_REQUEST: {
      return {
        ...state,
        loading: true,
        details: initialTariff,
      };
    }

    case GET_TARIFF_DETAILS_SUCCESS: {
      const { definition } = payload;
      const tariffPrices = definition.prices.map((it, i) => {
        return {
          ...it,
          id: i + 1,
        };
      });

      const tariffSeasonChart = definition.seasons.map((it, i) => {
        return {
          ...it,
          id: i,
        };
      });

      const tariffSeasons = getTariffSeasons(tariffSeasonChart);

      const tariffFeatures = definition?.features || {};

      return {
        ...state,
        loading: false,
        details: payload,
        tariffPrices,
        tariffSeasons: orderTariffSeasons(tariffSeasons),
        tariffSeasonChart,
        tariffColors: getTariffColorsByPrices(tariffPrices),
        isTariffUpdated: false,
        tariffFeatures,
      };
    }

    case GET_TARIFF_DETAILS_FAILURE: {
      return {
        ...state,
        loading: false,
      };
    }

    case RESET_TARIFF_DETAILS: {
      return {
        ...state,
        tariffPrices: [],
        tariffSeasons: [],
        tariffSeasonChart: [],
        tariffColors: [],
        selectedConfiguredSeason: null,
        isTariffUpdated: false,
        tariffFeatures: {}
      };
    }

    case POST_TARIFF_REQUEST:
    case UPDATE_TARIFF_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }

    case POST_TARIFF_SUCCESS:
    case UPDATE_TARIFF_SUCCESS: {
      return {
        ...state,
        loading: false,
        isTariffUpdated: false,
      };
    }

    case POST_TARIFF_FAILURE:
    case UPDATE_TARIFF_FAILURE: {
      return {
        ...state,
        loading: false,
      };
    }

    case CLEAR_TARIFF: {
      return {
        ...state,
        ...initialState,
      };
    }

    case ADD_EDIT_TOU_PERIOD: {
      const { formData, selectedPeriod } = payload;
      const tariffPrices = cloneDeep(state.tariffPrices);
      if (formData?.id) {
        const index = tariffPrices.findIndex((it) => it.id === formData?.id);
        tariffPrices[index] = formData;
      } else {
        tariffPrices.push({
          ...formData,
          id: tariffPrices.length + 1,
        });
      }

      let tariffSeasonChart = cloneDeep(state.tariffSeasonChart);

      if (!isEmpty(selectedPeriod)) {
        tariffSeasonChart = updateTimePeriodName(
          state.tariffSeasonChart,
          selectedPeriod?.time_period,
          formData?.time_period,
        );
      }

      return {
        ...state,
        tariffPrices,
        tariffColors: getTariffColorsByPrices(tariffPrices),
        isTariffUpdated: true,
        tariffSeasonChart,
      };
    }

    case DELETE_TOU_PERIOD: {
      let tariffPrices = cloneDeep(state.tariffPrices);

      tariffPrices = tariffPrices.filter((it) => it.id !== payload.id);

      return {
        ...state,
        tariffPrices,
        tariffColors: getTariffColorsByPrices(tariffPrices),
        isTariffUpdated: true,
      };
    }

    case ADD_EDIT_SEASON_DATE_RANGE: {
      const tariffSeasons = updateSeasonDateRange(state.tariffSeasons, payload);

      const tariffSeasonChart = convertSeasonToChart(
        tariffSeasons,
        state.tariffSeasonChart,
      );

      return {
        ...state,
        tariffSeasons: orderTariffSeasons(tariffSeasons),
        tariffSeasonChart: tariffSeasonChart,
        isTariffUpdated: true,
      };
    }

    case DELETE_SEASON_DATE_RANGE: {
      const tariffSeasons = deleteUpdteSeasonDateRange(
        state.tariffSeasons,
        payload,
      );

      const tariffSeasonChart = convertSeasonToChart(
        tariffSeasons,
        state.tariffSeasonChart,
      );

      return {
        ...state,
        tariffSeasons: orderTariffSeasons(tariffSeasons),
        tariffSeasonChart: tariffSeasonChart,
        isTariffUpdated: true,
      };
    }

    case ADD_EDIT_PERIOD_TIME_RANGE: {
      const { formData, pricingPeriod } = payload;

      const result = updatePeriodTimeRange(
        formData,
        state.tariffSeasonChart,
        state.selectedConfiguredSeason,
        pricingPeriod,
      );

      return {
        ...state,
        tariffSeasonChart: result.tariffSeasonChart,
        selectedConfiguredSeason: result.selectedConfiguredSeason,
        isTariffUpdated: true,
      };
    }

    case DELETE_PERIOD_TIME_RANGE: {
      const { formData, pricingPeriod } = payload;

      const result = deleteTariffPeriodTimeRange(
        formData,
        state.tariffSeasonChart,
        state.selectedConfiguredSeason,
        pricingPeriod,
      );

      return {
        ...state,
        tariffSeasonChart: result.tariffSeasonChart,
        selectedConfiguredSeason: result.selectedConfiguredSeason,
        isTariffUpdated: true,
      };
    }

    case ADD_EDIT_DAYS_OF_WEEK: {
      const selectedConfiguredSeason = cloneDeep(
        state.selectedConfiguredSeason,
      );
      selectedConfiguredSeason.days_of_week = payload;

      const tariffSeasonChart = cloneDeep(state.tariffSeasonChart);

      const index = tariffSeasonChart.findIndex(
        (it) => it.name === selectedConfiguredSeason.name,
      );
      tariffSeasonChart[index] = selectedConfiguredSeason;

      return {
        ...state,
        selectedConfiguredSeason,
        tariffSeasonChart,
        isTariffUpdated: true,
      };
    }

    case SET_SELECTED_CONFIGURED_SEASON: {
      return {
        ...state,
        selectedConfiguredSeason: payload,
      };
    }

    case ADD_EDIT_TARIFF_FEATURE: {
      const feature = payload;
      let updatedFeatures = { ...state.tariffFeatures };
      if (feature && feature.id) {
        updatedFeatures[feature.id] = feature;
      }
      return {
        ...state,
        tariffFeatures: updatedFeatures,
        isTariffUpdated: true,
      };
    }

    case DELETE_TARIFF_FEATURE: {
      const feature = payload;
      let updatedFeatures = { ...state.tariffFeatures };
      delete updatedFeatures[feature.id];
      return {
        ...state,
        tariffFeatures: updatedFeatures,
        isTariffUpdated: true,
      };
    }

    case DELETE_TARIFF_FEATURE_PERIOD: {
      const { feature, daysOfWeekIdx } = payload;
      const selectedConfiguredSeason = cloneDeep(state.selectedConfiguredSeason);
      const features = { ...selectedConfiguredSeason.days_of_week[daysOfWeekIdx].features };
      delete features[feature.id];
      selectedConfiguredSeason.days_of_week[daysOfWeekIdx].features = features;

      const tariffSeasonChart = cloneDeep(state.tariffSeasonChart);

      const index = tariffSeasonChart.findIndex(
        (it) => it.name === selectedConfiguredSeason.name,
      );
      tariffSeasonChart[index] = selectedConfiguredSeason;

      return {
        ...state,
        selectedConfiguredSeason,
        tariffSeasonChart,
        isTariffUpdated: true,
      };
    }

    case ADD_EDIT_TARIFF_FEATURE_PERIOD: {
      const { feature, daysOfWeekIdx } = payload;
      const selectedConfiguredSeason = cloneDeep(state.selectedConfiguredSeason);
      const features = { ...selectedConfiguredSeason.days_of_week[daysOfWeekIdx].features };
      features[feature.id] = feature;
      selectedConfiguredSeason.days_of_week[daysOfWeekIdx].features = features;

      const tariffSeasonChart = cloneDeep(state.tariffSeasonChart);

      const index = tariffSeasonChart.findIndex(
        (it) => it.name === selectedConfiguredSeason.name,
      );
      tariffSeasonChart[index] = selectedConfiguredSeason;

      return {
        ...state,
        selectedConfiguredSeason,
        tariffSeasonChart,
        isTariffUpdated: true,
      };
    }

    default:
      return state;
  }
}
